import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { mockData } from "../mockData";
import { ThankComponent } from "./thank/thank.component";
import { PayComponent } from "./pay/pay.component";

let routes: Routes = [
  {
    path: "t/:id",
    component: ThankComponent,
  },
  {
    path: "r/:id",
    component: PayComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
